// WebGL context loss (IMPLEMENTATION §2.9 "Save", §3 M11): `webglcontextlost` on the game canvas →
// preventDefault (the browser may restore it; Phaser's own handler does the same), then `onLost` (the app
// saves and shows the ContextLostOverlay: "Tap to reload"). The baked atlas pages are scratch canvases freed
// after upload, so a restored context would draw blank textures: the app always reloads (the save keeps the
// state) instead of trying to rebuild in place. `onRestored` is informational.

export interface ContextLossHandlers {
  onLost(): void;
  onRestored?(): void;
}

/** Watches `canvas`; returns the uninstaller. `onLost` runs once per loss. */
export function watchContextLoss(canvas: HTMLCanvasElement, h: ContextLossHandlers): () => void {
  let lost = false;
  const onLost = (ev: Event): void => {
    ev.preventDefault();
    if (lost) return;
    lost = true;
    h.onLost();
  };
  const onRestored = (): void => {
    lost = false;
    h.onRestored?.();
  };
  canvas.addEventListener('webglcontextlost', onLost, false);
  canvas.addEventListener('webglcontextrestored', onRestored, false);
  return () => {
    canvas.removeEventListener('webglcontextlost', onLost, false);
    canvas.removeEventListener('webglcontextrestored', onRestored, false);
  };
}
